import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-204dc3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","width":"100%"} }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  key: 0,
  style: {"position":"absolute","left":"130px","top":"-3px","color":"red"}
}

import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { Ref, ref, computed, onMounted, reactive, watch } from "vue";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import MoreDetails from "./moreDetails.vue";
import { getComponentUiText } from "@/utils/utilities";
import { idWizardPage as idPage, statusPage } from "@/utils/constants";

import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'listBrand',
  props: {
  item: {
    type: Object,
    required: true,
  },
  currentIndex: {
    type: Number,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: ["changeStatusAddBrand"],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;

const isMoreDetails = ref(false);
const currentOrg = computed(() => store.state.Org.currentOrg);
onMounted(() => {
  store.commit("SetupWizard/SET_CURRENT_ORG", currentOrg.value.id);
});

const item = ref(props.item);
watch(
  () => props.item,
  (newVal) => {
    item.value = newVal;
  },
);
const accordionNumber = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (
    setupWizard.questions[currentOrg.value.id]?.brands[0]?.values.length > 0
  ) {
    return setupWizard.questions[currentOrg.value.id].brands[0].values.map(
      (el) => ({
        ...el,
        showAccordion: false,
      }),
    );
  } else {
    return [];
  }
});

const bodyAPIError = computed(() => {
  if (
    !item.value.id &&
    props.statusInPage.dataError.length > 0 &&
    item.value.isCallAPI
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError.find((i) => i.id === item.value.id)
  );
});

const statusInPageClone = ref(bodyAPIError);

const rules = {
  brandName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  return !v$.value.$error;
};
__expose({
  saveChanges,
});

const updateStore = (item, index) => {
  store.commit("SetupWizard/SET_BRAND_NAME", {
    value: item,
    _index: index,
    currentOrg: currentOrg.value.id,
  });
  emits("changeStatusAddBrand", true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WizardDetailWrapper, {
      class: _normalizeClass(['tw-mb-[25px]']),
      title: item.value.title,
      "show-accordion": item.value.showAccordion,
      "show-question": false,
      data: __props.data,
      "page-active": _unref(idPage).brandsPage,
      validation: _unref(v$).brandName,
      "show-validate-now": true,
      "is-api-error": statusInPageClone.value,
      onInput: _cache[2] || (_cache[2] = ($event: any) => (updateStore(item.value, __props.currentIndex)))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.brandName) = $event)),
            class: "enter__name",
            placeholder: 
              _unref(getComponentUiText)(
                'app-menu-submenu-home-setup-wizard-brand-name-prompt-1',
              )
            ,
            style: {"border":"unset","background-color":"unset"},
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, null, 8, _hoisted_2), [
            [_vModelText, item.value.brandName]
          ]),
          (!item.value.brandName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (isMoreDetails.value)
          ? (_openBlock(), _createBlock(MoreDetails, {
              key: 0,
              "classes-more-detail": '!tw-p-0',
              "is-show-questions": false
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "show-accordion", "data", "page-active", "validation", "is-api-error"])
  ]))
}
}

})